import { jsxs as w, jsx as t, Fragment as I } from "react/jsx-runtime";
import { useState as h, useRef as C, useEffect as p } from "react";
import n from "./popover.module.js";
import { useOutsideClick as j } from "../../hooks/useClickOutside.js";
import { IconButton as z } from "../IconButton/index.js";
import { useOutsideKeyDown as D } from "../../hooks/useOutsideKeyDown.js";
import { IconClose as K } from "../Icon/icons/IconClose.js";
const V = ({
  children: y,
  content: g,
  placement: r = "right",
  ariaLabel: k,
  ariaLabelClose: E = "Close",
  offset: a = "-50%",
  width: b
}) => {
  const [i, o] = h(!1), [u, m] = h({
    translateX: a,
    translateY: "0px"
  }), l = C(null), d = C(null), x = () => {
    o(!0);
  };
  j(l, () => {
    o(!1);
  }), D(l, () => {
    o(!1);
  });
  const L = () => {
    o(!1);
  }, N = (e) => {
    e.key === "Enter" && (o(!0), window.setTimeout(
      () => {
        var s;
        return (s = document.getElementById("closeButton")) == null ? void 0 : s.focus();
      },
      0
    ));
  };
  p(() => {
    const e = (s) => {
      s.key === "Escape" && o(!1);
    };
    return window.addEventListener("keydown", e), () => {
      window.removeEventListener("keydown", e);
    };
  }, []);
  const f = () => {
    if (i && l.current && d.current) {
      const e = d.current.getBoundingClientRect(), s = window.innerWidth;
      let c = a;
      const v = "0px", R = e.left, B = e.right;
      R < 0 && (c = "-10%", m({ translateX: c, translateY: v })), B > s && (c = "-90%", m({ translateX: c, translateY: v }));
    }
  };
  return p(() => {
    f();
  }, [i, r, a]), p(() => {
    const e = () => {
      f();
    };
    return window.addEventListener("resize", e), () => {
      window.removeEventListener("resize", e);
    };
  }, [i, r, a]), /* @__PURE__ */ w("div", { className: n.popoverWrapper, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: n.popover,
        tabIndex: 0,
        onKeyDown: N,
        onClick: x,
        "aria-label": k,
        role: "button",
        "aria-expanded": i,
        children: y
      }
    ),
    i && /* @__PURE__ */ t(I, { children: /* @__PURE__ */ w(
      "div",
      {
        className: `${n.popoverContentWrapper} ${n[r]}`,
        ref: d,
        style: {
          width: b,
          transform: r === "top" || r === "bottom" ? `translateX(${u.translateX}` : `translateY${u.translateY})`
        },
        children: [
          /* @__PURE__ */ t("div", { className: n.popoverClose, children: /* @__PURE__ */ t(
            z,
            {
              ariaLabel: E,
              onClick: L,
              size: "s",
              id: "closeButton",
              children: /* @__PURE__ */ t(K, { className: n.closeIcon })
            }
          ) }),
          /* @__PURE__ */ t("div", { className: n.popoverContent, ref: l, children: /* @__PURE__ */ t("span", { children: g }) })
        ]
      }
    ) })
  ] });
};
export {
  V as Popover
};
